// src/js-dot/api/api-logger.ts
import { PrimitiveLogger } from "@js-dot/core";
var API_LOG = new PrimitiveLogger({
  debug: "debug"
});
var ApiLogger = API_LOG;
export { API_LOG, ApiLogger };
